// SearchForm js
import React, {Component} from 'react';
//import MapPopup from '../components/MapPopup';
import { Api } from '../common/variables';
import webservice from '../services/webservice';

// Redux set data
import { connect } from "react-redux";

// Language
import utils from '../common/utils';

class SearchForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			searchTexts : utils.Language( 'lang_searchProducts', this.props.language ),
			searchText  : '',
			searchSuggestion : []
		};

		setTimeout(
			function() {
				this.setState({
					searchTexts : utils.Language( 'lang_searchProducts', this.props.language )
				});
				var vars = [], hash;
			    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
				if ( hashes ) {
					for(var i = 0; i < hashes.length; i++)
				    {
				        hash = hashes[i].split('=');
				        vars.push(hash[0]);
				        vars[hash[0]] = hash[1];
				    }
					if ( vars['keyword'] ) {
						let keyword = vars['keyword'].replace(/%20/g, ' ');
							keyword = keyword.replace( /[^a-zA-Z0-9.\s]/g, "" );
						this.setState({
							searchText : keyword,
						});
					}
				}
			}
			.bind( this ),
			50
		);
	}

	handlePageChange( suggestion = null ) {
		let searchValue = this.searchValue.value;
		if ( suggestion ) {
			searchValue = suggestion;
		}

		if ( '' !== searchValue || '' === searchValue ) {
			this.setState({
				type       : 'error',
				searchText : searchValue,
			});
			window.location.href = '/search?keyword=' + searchValue;
		} else {
			this.setState({
				type       : 'error',
				searchTexts : utils.Language( 'lang_searchEmptyKeyword', this.props.language )
			});
		}
	}

	ToggleMenu=()=>{
		this.setState({
			isActive: ! this.state.isActive
		})
	}
	// social media icon
	

	// save search input value
	saveSearch = async ( e ) => {
		this.setState({
			searchSuggestion: [],
			searchText: e.replace( /[^a-zA-Z0-9.*\s]/g, "" )
		})

		if ( e.replace( /[^a-zA-Z0-9.*\s]/g, "" ) ) {
			let params = {
				'lang' : this.props.language,
				'vendorID': this.props.vendorInfos.data.id,
				'keyword' : e.replace( /[^a-zA-Z0-9.*\s]/g, "" )
			}
			const getSearchSuggestion = await webservice.httpPost( Api.method.getSearchSuggestion, params );
			if ( 'ok' === getSearchSuggestion.status ) {
				this.setState({
					searchSuggestion: getSearchSuggestion.data,
				})
			}
		} else {
			this.onBlurStatus();
		}
	}

	onBlurStatus = () => {
		setTimeout( () => {
			this.setState({
				searchSuggestion: [],
			})
		}, 100 );
	}

	render() {
		return (
		<div className="wrapper wrapper_1200 menu-right-section">
			{/* for phone number */}
			<div className='contact_phone'>
		 	    <svg className="phone-icon mr-2" xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 13.744 13.732"><defs></defs><path className="a" d="M35.385,36.608a10.8,10.8,0,0,0,2.3,3.12,12.038,12.038,0,0,0,2.41,1.646c.077.042.108,0,.15-.041.305-.306.619-.6.915-.919a1.088,1.088,0,0,1,1.087-.325,1.6,1.6,0,0,1,.686.3,11.309,11.309,0,0,1,1.9,1.9,1.516,1.516,0,0,1,.328,1.2,1,1,0,0,1-.192.439,3.607,3.607,0,0,1-2.273,1.35,4.074,4.074,0,0,1-1.5-.081,9.735,9.735,0,0,1-3.7-1.637,18.734,18.734,0,0,1-4.91-5.051,6.544,6.544,0,0,1-1.063-2.633,4.68,4.68,0,0,1,.391-2.962,3.559,3.559,0,0,1,.992-1.129,1.265,1.265,0,0,1,1.446.062,14.667,14.667,0,0,1,1.93,1.841,1.858,1.858,0,0,1,.468,1.129.938.938,0,0,1-.295.739q-.486.485-.973.97A.837.837,0,0,1,35.385,36.608Z" transform="translate(-31.445 -31.594)" /></svg>                                    
                <a href="tel:01 4426094"> 01 4426094</a>
		 	</div>
			<div className=' mx-2'>
				{/* social media icons */}
							<div id="footer_bottom-right" className="contact_info " style={{ display: 'block' }}>						
								<div className="footer_social_icons">
									<div className="footer_phone-div footer_phone-div-call">
											{/* <div className="footer_phones"> */}
												<a href="tel: 01 4426094">
												<svg className="phone-icon" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 13.744 13.732"><defs></defs><path className="a" d="M35.385,36.608a10.8,10.8,0,0,0,2.3,3.12,12.038,12.038,0,0,0,2.41,1.646c.077.042.108,0,.15-.041.305-.306.619-.6.915-.919a1.088,1.088,0,0,1,1.087-.325,1.6,1.6,0,0,1,.686.3,11.309,11.309,0,0,1,1.9,1.9,1.516,1.516,0,0,1,.328,1.2,1,1,0,0,1-.192.439,3.607,3.607,0,0,1-2.273,1.35,4.074,4.074,0,0,1-1.5-.081,9.735,9.735,0,0,1-3.7-1.637,18.734,18.734,0,0,1-4.91-5.051,6.544,6.544,0,0,1-1.063-2.633,4.68,4.68,0,0,1,.391-2.962,3.559,3.559,0,0,1,.992-1.129,1.265,1.265,0,0,1,1.446.062,14.667,14.667,0,0,1,1.93,1.841,1.858,1.858,0,0,1,.468,1.129.938.938,0,0,1-.295.739q-.486.485-.973.97A.837.837,0,0,1,35.385,36.608Z" transform="translate(-31.445 -31.594)" /></svg>

													{/* 01-4426094 */}
													</a>
											{/* </div> */}
									</div>
									<div className="footer_phone-div footer_phone-div-whatsapp">
											<a href="viber://chat?number=+9779860973324">
												<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="50" height="50" viewBox="0 0 50 50">
													<path className="a" d="M 44.78125 13.15625 C 44 10.367188 42.453125 8.164063 40.1875 6.605469 C 37.328125 4.632813 34.039063 3.9375 31.199219 3.511719 C 27.269531 2.925781 23.710938 2.84375 20.316406 3.257813 C 17.136719 3.648438 14.742188 4.269531 12.558594 5.273438 C 8.277344 7.242188 5.707031 10.425781 4.921875 14.734375 C 4.539063 16.828125 4.28125 18.71875 4.132813 20.523438 C 3.789063 24.695313 4.101563 28.386719 5.085938 31.808594 C 6.046875 35.144531 7.722656 37.527344 10.210938 39.09375 C 10.84375 39.492188 11.65625 39.78125 12.441406 40.058594 C 12.886719 40.214844 13.320313 40.367188 13.675781 40.535156 C 14.003906 40.6875 14.003906 40.714844 14 40.988281 C 13.972656 43.359375 14 48.007813 14 48.007813 L 14.007813 49 L 15.789063 49 L 16.078125 48.71875 C 16.269531 48.539063 20.683594 44.273438 22.257813 42.554688 L 22.472656 42.316406 C 22.742188 42.003906 22.742188 42.003906 23.019531 42 C 25.144531 41.957031 27.316406 41.875 29.472656 41.757813 C 32.085938 41.617188 35.113281 41.363281 37.964844 40.175781 C 40.574219 39.085938 42.480469 37.355469 43.625 35.035156 C 44.820313 32.613281 45.527344 29.992188 45.792969 27.019531 C 46.261719 21.792969 45.929688 17.257813 44.78125 13.15625 Z M 35.382813 33.480469 C 34.726563 34.546875 33.75 35.289063 32.597656 35.769531 C 31.753906 36.121094 30.894531 36.046875 30.0625 35.695313 C 23.097656 32.746094 17.632813 28.101563 14.023438 21.421875 C 13.277344 20.046875 12.761719 18.546875 12.167969 17.09375 C 12.046875 16.796875 12.054688 16.445313 12 16.117188 C 12.050781 13.769531 13.851563 12.445313 15.671875 12.046875 C 16.367188 11.890625 16.984375 12.136719 17.5 12.632813 C 18.929688 13.992188 20.058594 15.574219 20.910156 17.347656 C 21.28125 18.125 21.113281 18.8125 20.480469 19.390625 C 20.347656 19.511719 20.210938 19.621094 20.066406 19.730469 C 18.621094 20.816406 18.410156 21.640625 19.179688 23.277344 C 20.492188 26.0625 22.671875 27.933594 25.488281 29.09375 C 26.230469 29.398438 26.929688 29.246094 27.496094 28.644531 C 27.574219 28.566406 27.660156 28.488281 27.714844 28.394531 C 28.824219 26.542969 30.4375 26.726563 31.925781 27.78125 C 32.902344 28.476563 33.851563 29.210938 34.816406 29.917969 C 36.289063 31 36.277344 32.015625 35.382813 33.480469 Z M 26.144531 15 C 25.816406 15 25.488281 15.027344 25.164063 15.082031 C 24.617188 15.171875 24.105469 14.804688 24.011719 14.257813 C 23.921875 13.714844 24.289063 13.199219 24.835938 13.109375 C 25.265625 13.035156 25.707031 13 26.144531 13 C 30.476563 13 34 16.523438 34 20.855469 C 34 21.296875 33.964844 21.738281 33.890625 22.164063 C 33.808594 22.652344 33.386719 23 32.90625 23 C 32.851563 23 32.796875 22.996094 32.738281 22.984375 C 32.195313 22.894531 31.828125 22.378906 31.917969 21.835938 C 31.972656 21.515625 32 21.1875 32 20.855469 C 32 17.628906 29.371094 15 26.144531 15 Z M 31 21 C 31 21.550781 30.550781 22 30 22 C 29.449219 22 29 21.550781 29 21 C 29 19.347656 27.652344 18 26 18 C 25.449219 18 25 17.550781 25 17 C 25 16.449219 25.449219 16 26 16 C 28.757813 16 31 18.242188 31 21 Z M 36.710938 23.222656 C 36.605469 23.6875 36.191406 24 35.734375 24 C 35.660156 24 35.585938 23.992188 35.511719 23.976563 C 34.972656 23.851563 34.636719 23.316406 34.757813 22.777344 C 34.902344 22.140625 34.976563 21.480469 34.976563 20.816406 C 34.976563 15.957031 31.019531 12 26.160156 12 C 25.496094 12 24.835938 12.074219 24.199219 12.21875 C 23.660156 12.34375 23.125 12.003906 23.003906 11.464844 C 22.878906 10.925781 23.21875 10.390625 23.757813 10.269531 C 24.539063 10.089844 25.347656 10 26.160156 10 C 32.125 10 36.976563 14.851563 36.976563 20.816406 C 36.976563 21.628906 36.886719 22.4375 36.710938 23.222656 Z">
													</path>
												</svg>
											</a>
											{/* <div className="footer_phones">
												+977-9860973324
											</div> */}
									</div>
				
									<div className="footer_email footer_email-fb " >
										<a href="https://www.facebook.com/omvalleyliquors/" target="_blank" rel="noopener noreferrer" className="social icon_fb" style={{ pointerEvents: 'all' }}>
											<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="50" height="50" viewBox="0 0 50 50">
												<path className="a" d="M32,11h5c0.552,0,1-0.448,1-1V3.263c0-0.524-0.403-0.96-0.925-0.997C35.484,2.153,32.376,2,30.141,2C24,2,20,5.68,20,12.368 V19h-7c-0.552,0-1,0.448-1,1v7c0,0.552,0.448,1,1,1h7v19c0,0.552,0.448,1,1,1h7c0.552,0,1-0.448,1-1V28h7.222 c0.51,0,0.938-0.383,0.994-0.89l0.778-7C38.06,19.518,37.596,19,37,19h-8v-5C29,12.343,30.343,11,32,11z">
												</path>
											</svg>
										{/* <div className="footer_mail">
											fb.com/omvalleyliquors
										</div>	 */}
										</a>
										
									</div>
								</div>							
						</div>
	
			</div>

			<div className="menu-right-section-div">
				<span className={this.state.isActive===true ? 'icon_search showinmobile mobile-search show' : 'icon_search showinmobile mobile-search hide'} onClick={this.ToggleMenu}></span>
				
				<div className={this.state.isActive===true ? "search_wrapper show" : "search_wrapper hide" + ( 'error' === this.state.type ? 'search_error' : '' )}>
					
					<div className="search_input-wrapper">
						<input type="text" maxLength="50" className="search_input" placeholder={ this.state.searchTexts } value={ this.state.searchText || '' } ref={ el => this.searchValue=el }
							onChange = { e => { this.saveSearch( e.target.value ) } }
							onKeyPress={ event => {
								if ( event.key === 'Enter' ) {
									this.handlePageChange();
								}
							}}
							onBlur={() => {
								this.onBlurStatus();
							}}
						/>
						<button className="btn btn-radius search-btn" onClick={ ( e ) => { this.handlePageChange() } }><span className="icon_search"></span></button>
					</div>
				
				

				</div>
				{/*<div className="mapicon">{<MapPopup signup={false} />}</div>*/}
				<ul className="autocompletelist">
				{
				( this.state.searchSuggestion && this.state.searchSuggestion.length > 0 ) ?
					this.state.searchSuggestion.map( (suggestion, index) => {
						return (
						<li className="searchsuggestion-list" key={index} onClick={ ( e ) => {  this.handlePageChange( suggestion ) } }>
						{ suggestion }
						</li>
						)
					})
				: null
				}
				</ul>
			</div>
		</div>
		);
	}
}

const mapStateToProps = state => ({
	...state
});

export default connect( mapStateToProps, null )(SearchForm);